import { render, staticRenderFns } from "./nf-cascader1.vue?vue&type=template&id=af232fc0"
import script from "./nf-cascader1.vue?vue&type=script&lang=js"
export * from "./nf-cascader1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports